/**
 * @file Visual badge for page workflow status.
 */
import type { PageStatus } from "@/lib/shared";
import { getPageStatusLabel } from "@/lib/page-status-labels";

const styles: Record<PageStatus, string> = {
  draft: "bg-zinc-200 text-zinc-800",
  in_review: "bg-amber-100 text-amber-900",
  approved: "bg-emerald-100 text-emerald-900",
  published: "bg-sky-100 text-sky-900",
  published_draft: "bg-violet-100 text-violet-900",
  published_in_review: "bg-orange-100 text-orange-900",
  unpublished: "bg-slate-200 text-slate-800",
  rejected: "bg-rose-100 text-rose-900",
};

/**
 * Renders a compact status pill.
 */
export function PageStatusBadge({ status }: { status: string }) {
  const cls = styles[status as PageStatus] ?? "bg-zinc-100 text-zinc-700";
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {getPageStatusLabel(status)}
    </span>
  );
}
